import script from "./ComicFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ComicFooter.vue?vue&type=script&setup=true&lang=js"

import "./ComicFooter.vue?vue&type=style&index=0&id=4ad9da5d&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad9da5d"]])

export default __exports__